<template>
  <b-card style="padding:40px;">
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="fullPage"
    ></loading>

    <h5><b>LIST OF STOCKOUT</b></h5>
    <hr />
    <b-row>
      <b-form-group class="col-md-4">
        <label :for="`input-size`"
          >State <span class="danger-new"> *</span></label
        >
        <b-form-select
          v-model="form.state"
          :options="select.state"
          class="input-new"
          required
          @change="getUpline"
        ></b-form-select>
      </b-form-group>

      <b-form-group class="col-md-4" v-if="form.state !== ''">
        <label :for="`input-size`"
          >Stockist <span class="danger-new"> *</span></label
        >
        <b-form-select
          v-model="form.upline"
          :options="select.upline"
          class="input-new"
          required
          @change="getYearUpline"
        ></b-form-select>
      </b-form-group>
    </b-row>

    <b-row>
      <b-form-group class="col-md-4" v-if="form.upline !== ''">
        <label :for="`input-size`"
          >Year <span class="danger-new"> *</span></label
        >
        <b-form-select
          v-model="form.year"
          :options="select.year"
          class="input-new"
          required
          @change="filterMonth"
        ></b-form-select>
      </b-form-group>

      <b-form-group class="col-md-4" v-if="form.year !== ''">
        <label :for="`input-size`"
          >Month <span class="danger-new"> *</span></label
        >
        <b-form-select
          v-model="form.month"
          :options="select.month"
          class="input-new"
          required
        ></b-form-select>
      </b-form-group>
    </b-row>
    <br />

    <div v-if="form.upline !== '0' && form.year !== '' && form.month !== ''">
      <TableStockoutIndex
        :fields="fields.fields"
        :state="form.state"
        :upline="form.upline"
        :year="form.year"
        :month="form.month"
        :filter="this.filter"
        :page="this.page"
        :date="this.date"
        :name="this.name"
        :outlet_name="this.outlet_name"
        @getItems="checkItems($event)"
      />
    </div>

    <div
      v-if="
        itemLength >= 1 &&
          form.month !== '' &&
          form.year !== '' &&
          form.upline !== '0'
      "
    >
      <b-row>
        <b-col md="4">
          <b-form-select
            v-model="form.excel_type"
            :options="select.excel_type"
            class="input-new"
            required
            @change="changeType"
          ></b-form-select>
        </b-col>
        <b-col
          md="4"
          v-if="
            form.excel_type == '3' ||
              form.excel_type == '4' ||
              form.excel_type == '5'
          "
        >
          <b-form-select
            v-model="form.sub_excel_type"
            :options="select.sub_excel_type"
            class="input-new"
            required
          ></b-form-select>
        </b-col>
        <b-col>
          <b-button variant="primary" size="sm" @click="downloadExcel">
            GENERATE REPORT
          </b-button>
        </b-col>
      </b-row>
    </div>
    <div
      v-else-if="
        (form.state === '0' || form.upline === '0') && form.year && form.month
      "
    >
      <b-row>
        <b-col>
          <b-button variant="primary" size="sm" @click="downloadExcel">
            GENERATE ALL REPORT
          </b-button>
        </b-col>
      </b-row>
    </div>
  </b-card>
</template>

<script>
import TableStockoutIndex from "@/table/admin/stockout/TableStockoutIndex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import SuccessGenerateReport from "@/pages/Notifications/SuccessGenerateReport";
import Failed from "@/pages/Notifications/Failed";
export default {
  data() {
    return {
      isLoading: false,
      fullPage: true,

      itemLength: "",
      itemss: [],
      form: {
        state: "",
        upline: "",
        year: "",
        month: "",
        excel_type: "",
        sub_excel_type: ""
      },
      error: {
        state: "",
        upline: "",
        year: ""
      },

      filter: "",
      page: "",
      date: "",
      name: "",
      outlet_name: "",

      select: {
        state: [{ value: "", text: "Please Select" }],
        upline: [],
        year: [],
        month: [{ value: "", text: "Please Select" }],
        excel_type: [{ value: "", text: "Please Select" }],
        sub_excel_type: [{ value: "", text: "Please Select" }]
      },

      fields: {
        fields: [
          {
            label: "No",
            key: "index",
            sortable: false
          },
          {
            label: "Name",
            key: "name",
            sortable: true
          },
          {
            label: "Outlet Name",
            key: "outlet_name",
            sortable: true
          },
          {
            label: "Category",
            key: "category",
            sortable: true
          },
          // {
          //   label: "role",
          //   key: "role",
          //   sortable: true
          // },
          // {
          //   label: "Total price",
          //   key: "total",
          //   sortable: true
          // },
          {
            label: "Date",
            key: "date",
            sortable: true
          },
          {
            label: "Action",
            key: "action",
            sortable: false
          }
        ]
      }
    };
  },
  created() {
    this.getState();
    this.getReporType();
    this.getReportCategory();
    this.getMonth();

    if (this.$route.query.state !== undefined) {
      this.form.state = parseInt(this.$route.query.state);
      this.getUpline();
      this.form.upline = parseInt(this.$route.query.upline);
      this.getYearUpline();
      this.form.year = parseInt(this.$route.query.year);
      this.form.month = parseInt(this.$route.query.month);
      this.filter = this.$route.query.filter;
      this.page = this.$route.query.page;
      this.date = this.$route.query.date;
      this.name = this.$route.query.name;
      this.outlet_name = this.$route.query.outlet_name;
    }
  },
  methods: {
    checkItems(data) {
      this.itemLength = data;
    },

    filterMonth() {
      this.form.month = "";
      this.getMonth();
    },

    getState() {
      this.isLoading = true;
      this.$store.dispatch("getReftable", "state&all=1").then(res => {
        this.isLoading = false;
        res.data.data.state.forEach(element => {
          this.select.state.push({
            value: element.ref_code,
            text: element.desc
          });
        });
      });
    },
    getMonth() {
      this.isLoading = true;
      this.select.month = [{ value: "", text: "Please Select" }];
      if (this.form.upline === "0") {
        this.$store.dispatch("getReftable", "month").then(res => {
          this.isLoading = false;
          res.data.data.month.forEach(element => {
            this.select.month.push({
              value: element.ref_code,
              text: element.desc
            });
          });
        });
      } else {
        this.$store.dispatch("getReftable", "month&all=1").then(res => {
          this.isLoading = false;
          res.data.data.month.forEach(element => {
            this.select.month.push({
              value: element.ref_code,
              text: element.desc
            });
          });
        });
      }
    },
    getReporType() {
      this.isLoading = true;
      this.$store.dispatch("getReftable", "reportype").then(res => {
        this.isLoading = false;
        let data = res.data.data.reportype.filter(
          element => element.ref_code !== 7
        );
        data.forEach(element => {
          this.select.excel_type.push({
            value: element.ref_code,
            text: element.desc
          });
        });
      });
    },
    getReportCategory() {
      this.isLoading = true;
      this.$store.dispatch("getReftable", "reportcategory").then(res => {
        this.isLoading = false;
        res.data.data.reportcategory.forEach(element => {
          this.select.sub_excel_type.push({
            value: element.ref_code,
            text: element.desc
          });
        });
      });
    },

    getUpline() {
      this.isLoading = true;
      this.form.upline = "";
      this.form.month = "";
      this.form.year = "";
      this.select.upline = [];
      this.select.upline.push({ value: "", text: "Please Select" });
      this.$store.dispatch("getUplineStock", this.form.state).then(res => {
        this.isLoading = false;
        res.data.data.forEach(element => {
          this.select.upline.push({
            value: element.user_id,
            text: element.name
          });
        });
      });
      this.select.upline.push({ value: "0", text: "All" });
    },

    getYearUpline() {
      this.form.year = "";
      this.form.excel_type = "";
      this.form.sub_excel_type = "";
      this.select.year = [];
      this.select.year.push({ value: "", text: "Please Select" });
      let data = {
        upline: this.form.upline === "0" ? "" : this.form.upline,
        state: this.form.state ? this.form.state : ""
      };
      this.$store.dispatch("getYearUpline", data).then(res => {
        res.data.data.forEach(item => {
          this.select.year.push({
            value: item,
            text: item
          });
        });
      });
    },

    changeType() {
      if (this.form.excel_type === "3" || this.form.excel_type === "4") {
        this.form.sub_excel_type = "1";
      } else {
        this.form.sub_excel_type = "";
      }
    },

    downloadExcel() {
      this.checkForm();
      let download;
      if (
        this.error.state ||
        this.error.upline ||
        this.error.year ||
        this.error.month
      ) {
        download = false;
      } else {
        download = true;
      }

      if (download) {
        this.isLoading = true;
        let data = {
          user_id: this.form.upline,
          state: this.form.state,
          month: this.form.month,
          year: this.form.year,
          report_type: this.form.excel_type ? this.form.excel_type : 8,
          report_category: this.form.sub_excel_type
        };
        this.$store.dispatch("downloadExcelAdmin", data).then(res => {
          this.isLoading = false;
          if (res.data.response.code === 100) {
            this.$notify({
              component: SuccessGenerateReport,
              icon: "ti-check",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success"
            });

            window.open(
              `${process.env.VUE_APP_BASE_URL}/${res.data.data.path + ".xlsx"}`,
              "_blank"
            );
          } else {
            this.$notify({
              component: Failed,
              icon: "ti-close",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "danger"
            });
          }
        });
      }
    },
    checkForm() {
      this.error.state = "";
      this.error.upline = "";
      this.error.year = "";
      this.error.month = "";

      if (
        this.form.state &&
        this.form.upline &&
        this.form.year !== "" &&
        this.form.month !== ""
      )
        return true;
      if (this.form.state === "") this.error.state = "State required.";
      if (this.form.upline === "") this.error.upline = "Stockist required.";
      if (this.form.year === "") this.error.year = "Year required.";
      if (this.form.month === "") this.error.month = "Month required.";
      // e.preventDefault();
    }
  },
  components: {
    TableStockoutIndex,
    Loading
  }
  // components: {
  //   TableStockoutIndex
  // }
};
</script>
<style lang="css" scoped></style>
